import { createSlice } from '@reduxjs/toolkit';

type State = { buildings: Record<string, unknown> };

const initialState: State = { buildings: {} };

const locationStructureSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    updateLocations(state: State, action) {
      state.buildings = action.payload;
    },
  },
});

export const { updateLocations } = locationStructureSlice.actions;

export default locationStructureSlice.reducer;
